import { inject, Injectable } from '@angular/core';
import { UnleashService } from '@karelics/angular-unleash-proxy-client';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { User } from '@rd/types';
import { tap } from 'rxjs/operators';
import { AuthActionTypes } from '../auth/store/actions/auth.actions';

@Injectable()
export class UnleashInitEffects {
  actions$ = inject(Actions);
  unleashService = inject(UnleashService);

  unleashUserLoginInit$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActionTypes.LOGIN_USER),
        tap(({ payload }: { payload: User }) => {
          this.unleashService.unleash.updateContext({
            userId: payload.sub,
          });
        }),
      ),
    {
      dispatch: false,
    },
  );
}
